@if (visible) {
<div class="fixed inset-0 z-[100] flex items-center justify-center p-6">
  <div class="absolute inset-0 bg-[rgba(39,43,52,0.24)]" (click)="backdropClose()"></div>
  <div class="relative z-10 bg-light rounded-3xl shadow-custom w-[560px] max-w-full border border-[#9AA8BC20]"
    (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <!-- header -->
    <div class="flex items-start justify-between w-full px-6 pt-6 pb-2">
      <h2 class="font-poppins font-semibold text-base xs:text-[22px] leading-[24px] text-text-primary m-0">
        {{ title }}
      </h2>
      <button class="text-[10px] text-text-primary" (click)="close()" aria-label="Cerrar">
        <i class="fi fi-br-cross text-text-primary text-[10px]"></i>
      </button>
    </div>
    <div class="p-4 sm:p-6">
      @if (layout === 'options-horizontal') {
      @if (showModalDisclaimer) {
      <div class="flex items-center bg-warning-200 rounded-2xl p-4 mb-4 xs:mb-6 -mt-2">
        <i class="fi fi-sr-exclamation text-xl text-warning flex items-center"></i>
        <p class="text-sm text-text-primary font-poppins font-medium ml-3">
          Si deseas configurar un puntaje en esta lista, incluye una columna de puntaje en tu archivo (CSV o XML)
        </p>
      </div>
      }
      <p class="font-poppins font-medium text-[14px] text-[#1A212B] mb-4 xs:mb-6 leading-5">
        Define cómo importarás los datos de tu lista.
      </p>
      <div class="flex justify-center xs:gap-6">
        @for(opt of options; track opt.value || opt.title) {
        <button type="button"
          class="flex flex-col items-center gap-3 w-[160px] bg-transparent border-0 text-center rounded-2xl focus:outline-none"
          (click)="select(opt)">
          <div class="w-12 h-12 rounded-2xl flex items-center justify-center bg-primary-g300">
            @if (opt.icon && (opt.icon.startsWith('/') || opt.icon.startsWith('http'))) {
            <img [src]="opt.icon" alt="{{opt.title}}" class="w-6 h-6 object-contain" />
            } @else {
            <i [class]="opt.icon + ' text-2xl flex items-center text-[#1A212B99]'"></i>
            }
          </div>
          <div
            class="font-poppins font-semibold text-xs xs:text-base leading-[18px] xs:leading-[18px] text-text-primary ">
            {{ opt.title }}
          </div>
          @if (opt.description) {
          <div class="text-sm text-gray-500">{{ opt.description }}</div>
          }
        </button>
        }
      </div>
      }
      @else if (layout === 'select-vertical') {
      @if(subtitle) {
      <p class="text-sm text-text-primary font-poppins font-semibold mb-2">{{ subtitle }}</p>
      }
      <div class="space-y-2">
        @for(opt of options; track opt.value || opt.title) {
        <button type="button"
          class="w-full flex items-center justify-between gap-3 p-2 xs:p-3 rounded-2xl border transition" [ngClass]="{
                  'bg-primary-g50 border-primary-g300': selected === opt, 
                  'border-transparent': selected !== opt 
                }" (click)="select(opt)">
          <div class="flex items-center gap-3">
            <div class="w-14 h-14 rounded-2xl flex items-center justify-center bg-primary-g300" [ngClass]="{
                      'bg-primary-g500 text-[#F6F8FB]': selected === opt, 
                      'bg-primary-g300 text-[#1A212B99]': selected !== opt 
                    }">
              @if (opt.icon && (opt.icon.startsWith('/') || opt.icon.startsWith('http'))) {
              <img [src]="opt.icon" alt="{{opt.title}}" class="w-6 h-6 object-contain" />
              } @else {
              <i [class]="opt.icon + ' text-2xl flex items-center'"></i>
              }
            </div>
            <div class="text-left">
              <div class="font-poppins font-semibold text-sm text-text-primary">{{ opt.title }}</div>
              @if (opt.description) {
              <div class="text-xs leading-[18px] hidden xs:flex text-text-secondary">{{ opt.description }}</div>
              }
            </div>
          </div>
          <div class="flex items-center justify-center">
            <div class="w-6 h-6 rounded-lg border flex items-center justify-center transition-all duration-200"
              [class.bg-primary-g500]="selected === opt" [class.border-transparent]="selected === opt"
              [class.border-soft-gray]="selected !== opt">
              @if (selected === opt) {
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
              </svg>
              }
            </div>
          </div>
        </button>
        }
      </div>
      }
      @else if (layout === 'categories') {
      <!-- aviso arriba -->
      @if(showModalDisclaimer) {
      <div class="flex items-center gap-3 mb-6 p-4 rounded-2xl bg-[#FFF4D9] border border-[#F5E1B6]">
        <i class="fi fi-sr-exclamation text-xl text-warning"></i>
        <p class="text-sm text-text-primary font-poppins font-medium">
          Si deseas configurar un puntaje en esta lista, incluye una columna de puntaje en tu archivo (CSV o XML)
        </p>
      </div>
      }
    <div class="space-y-2 max-h-[280px] overflow-y-auto pr-2">
  @for(cat of options; track cat.value || cat.title) {
  <div class="rounded-2xl border border-soft-gray overflow-hidden px-2 py-2 sm:py-[15px]">
    <!-- header -->
    <div class="flex items-center justify-between gap-3">
      <div class="flex items-center min-w-0 flex-1">
        <div class="flex items-center min-w-0 flex-1">
          <div class="flex flex-row flex-wrap items-center">
            <div class="flex flex-nowrap items-center mr-2">
              <button type="button" class="leading-none mt-[2px] flex-shrink-0" (click)="toggleExpandFor(cat)"
                aria-label="expandir">
                <i class="text-text-primary"
                  [class]="isExpanded(cat) ? 'fi-rr-angle-small-down text-2xl leading-none' : 'text-2xl fi-rr-angle-small-right leading-none'"></i>
              </button>
              <div class="font-poppins font-medium text-sm text-text-primary leading-[20px] truncate max-w-40 xxs:max-w-56 xs:max-w-80 sm:max-w-96">{{ cat.title }}</div>
            </div>
            <div
              class="text-xs text-secundary-b300 font-poppins leading-5 font-medium inline-block bg-blue-bubble px-3 py-1 rounded-[13px] flex-shrink-0">
              {{ (cat.items || []).length }}
              {{ (cat.items || []).length === 1 ? 'campo' : 'campos' }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <!-- mostrar botones solo si la categoría es editable -->
        <button *ngIf="cat.editable" class="mt-[6px]" title="Agregar campo" (click)="onAddFieldClick($event, cat)">
          <i class="fi fi-rr-plus-small text-xl text-text-primary leading-none mt-2"></i>
        </button>
        <button *ngIf="cat.editable" class="text-2xl text-negative leading-none" title="Eliminar categoría"
          (click)="removeCategory(cat)">
          <i class="fi fi-rr-trash"></i>
        </button>
      </div>
    </div>
    <!-- contenido expandible -->
    @if (isExpanded(cat)) {
    <div class="pb-2 pt-2 gap-y-4 border-t border-soft-gray-outline mt-2">
      <ul class="list-disc space-y-4">
        @for(field of (cat.items || []); track field) {
        <li class="flex items-center justify-between">
          <span class="ml-4 text-text-primary font-poppins text-sm leading-5 before:content-['•'] before:mr-2 truncate">{{
            field }}</span>
          <!-- mostrar 'x' de eliminar solo si la categoria es editable -->
          <button *ngIf="cat.editable" class="text-xl text-neutrals-n100 items-center flex justify-center leading-none pl-4"
            (click)="removeFieldFromCategory(cat, $index)">
            <i class="fi fi-ss-cross-small leading-none mt-[2px]"></i>
          </button>
        </li>
        }
      </ul>
    </div>
    }
  </div>
  }
</div>
<div class="mt-2 p-2">
  <button type="button" class="flex items-center" (click)="addCategory()">
    <i class="fi-rr-plus-small text-lg leading-none mt-[2px] ml-[6px] mr-[4px]"></i>
    <span class="font-poppins font-medium text-base leading-6 text-text-primary">Agregar categoría</span>
  </button>
</div>
      }
    </div>
    <!-- footer -->
    @if (showFooter) {
    <div class="flex justify-center xs:justify-end gap-4 h-12 m-6">
      @if (btnCancel) {
       <app-buttons type="dark-borderless" [text]="cancelText" size="medium" typeButton="button" (buttonClick)="onCancelClick()">
      </app-buttons>
      }
      <app-buttons type="primary" [text]="continueText" size="medium" typeButton="button" [disabled]="!selected"
        (buttonClick)="confirm()">
      </app-buttons>
    </div>
    }
  </div>
</div>
}
